import KalimbaApp from "../components/KalimbaApp";


export default function Kalimba() {
 return <KalimbaApp />;
}
